import './interceptors';
import axios from '@didi/dajax/dist/dajax';
import qs from 'qs';
import { requestCommonParams } from './requestCommonParams';
import { getLocalStorage } from '@/utils/localStorage';
import fingerprint from '@/utils/fingerprint';

export function getCommonConfig(config) {
  return {
    timeout: 30000,
    headers: getLocalStorage('ticket')
      ? {
          Accept: 'application/json',
          ticket: getLocalStorage('ticket'),
        }
      : {
          Accept: 'application/json',
        },
    /**
     * TODO
     * author: lizhengnacl
     * 后端增加 Access-Control-Allow-Credentials: true
     * 再调整为 withCredentials: true
     */
    withCredentials: true,
    needEncrypt: false, // 不使用dajax内部的签名，使用dd05,能力通过拦截器生成
    ...config,
  };
}

export function addCommonParams(data = {}) {
  let params = { ...requestCommonParams() };
  return Object.assign({}, params, data);
}

export async function get(url = '', { param = {}, config = {} }) {
  await fingerprint.init();
  const commParams = addCommonParams();
  const params = Object.assign({}, commParams, param);
  const data = Object.assign({}, getCommonConfig(config), {
    params,
  });
  return axios.get(url, data);
}

export async function post(url = '', data = {}, config = {}) {
  await fingerprint.init();
  const params = addCommonParams(data);
  return axios.post(
    url,
    qs.stringify(params),
    Object.assign({}, getCommonConfig(config))
  );
}

// /**
//  * 适用于文件上传，不依赖el-upload组件
//  */
// export async function postFormData(url, data = {}, config = {}) {
//   const formData = new FormData();
//   const commParams = await addCommonParams();
//   const params = Object.assign({}, commParams, data);
//   for (let key in params) {
//     formData.append(key, params[key]);
//   }
//   return new Promise((resolve, reject) => {
//     const onprogress = config.onprogress || (() => void 0);
//     const xhr = new XMLHttpRequest();
//     xhr.timeout = 30 * 1000;
//     /**
//      * TODO
//      * author: lizhengnacl
//      * 后端增加 Access-Control-Allow-Credentials: true
//      * 再调整为 withCredentials: true
//      */
//     xhr.withCredentials = false;
//     xhr.open('post', url);
//     xhr.onreadystatechange = () => {
//       if (xhr.readyState === 4) {
//         if (xhr.status === 200) {
//           try {
//             resolve(JSON.parse(xhr.response));
//           } catch (e) {
//             resolve(xhr.response);
//           }
//         } else {
//           reject(xhr);
//         }
//       }
//     };
//     xhr.onerror = reject;
//     xhr.ontimeout = reject;
//     xhr.upload.onprogress = onprogress;
//     xhr.send(formData);
//   });
// }
